module.exports = __webpack_public_path__ + "img/photo-hit-beauty-2020.f7fcf303.jpg";